import { Duration } from "luxon";

/**
 * format a duration in seconds to a string
 *
 * @param seconds - the duration in seconds
 * @returns - the formatted duration (hh:mm:ss)
 */
export function formatSeconds(seconds: number) {
	const duration = Duration.fromObject({ seconds });
	return duration.as("hours") >= 1 ? duration.toFormat("hh:mm:ss") : duration.toFormat("mm:ss");
}
